export type WidgetPresentationText = {
  launcherLabel?: string;
  launcherLabelByLocale?: Partial<Record<"en" | "es", string>>;
  headerTitle?: string;
  headerTitleByLocale?: Partial<Record<"en" | "es", string>>;
};

export function resolveWidgetPresentationText(value: unknown, locale: string, field: "launcherLabel" | "headerTitle"): string {
  if (!value || typeof value !== "object") return "";
  const theme = value as Record<string, unknown>;
  const map = theme[`${field}ByLocale`];
  const localized = map && typeof map === "object" ? (map as Record<string, unknown>)[locale] : undefined;
  const text = typeof localized === "string" ? localized : theme[field];
  return typeof text === "string" ? text.trim().slice(0, field === "launcherLabel" ? 70 : 80) : "";
}
